// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Admin Applications ── */

/* Stat row — 5 cards, with a real progression down to phone width */
.aap__stats-row {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.85rem;
}

.aap__stat-card {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  min-width: 0; /* allow grid items to shrink below content size */
}

.aap__stat-top {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}
.aap__stat-icon {
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.aap__stat-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--admin-muted);
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.aap__stat-value {
  font-family: var(--font-body);
  font-size: 1.7rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
}
.aap__stat-change {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.75rem;
  font-weight: 500;
  margin: 0;
}
.aap__stat-change.up {
  color: var(--admin-green);
}
.aap__stat-change.down {
  color: var(--admin-red);
}

/* Main layout: table + optional detail */
.aap__layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}
.aap__layout--detail {
  grid-template-columns: 1fr 340px;
  align-items: start;
}

/* Filters */
.aap__filters {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 0.75rem;
}

.aap__search-wrap {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1;
  min-width: 160px;
}
.aap__search-icon {
  position: absolute;
  left: 0.75rem;
  font-size: 0.9rem;
  color: var(--admin-muted);
  pointer-events: none;
}
.aap__search {
  width: 100%;
  box-sizing: border-box;
  padding: 0.6rem 0.9rem 0.6rem 2.25rem;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  background: #fff;
  font-size: 0.84rem;
  color: var(--admin-text);
  outline: none;
  transition: border-color 0.15s;
}
.aap__search:focus {
  border-color: var(--admin-rust);
}
.aap__search::placeholder {
  color: #9ca3af;
}

.aap__select-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.aap__filter-select,
.aap__select {
  appearance: none;
  -webkit-appearance: none;
  padding: 0.6rem 2rem 0.6rem 0.9rem;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  background: #fff;
  font-size: 0.84rem;
  color: var(--admin-text);
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s;
  max-width: 100%;
}
.aap__filter-select:focus,
.aap__select:focus {
  border-color: var(--admin-rust);
}
.aap__select-icon {
  position: absolute;
  right: 0.6rem;
  font-size: 0.75rem;
  color: var(--admin-muted);
  pointer-events: none;
}

.aap__date-filter {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 0.9rem;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  background: #fff;
  font-size: 0.84rem;
  color: var(--admin-text);
  cursor: pointer;
  white-space: nowrap;
}
.aap__date-icon {
  font-size: 0.9rem;
  color: var(--admin-muted);
}

.aap__filters-right {
  margin-left: auto;
}
.aap__filter-btn {
  white-space: nowrap;
}

/* Table card */
.aap__table-card {
  padding: 0;
  overflow: hidden;
}

/* Desktop/tablet: scrollable table wrapper. Mobile: replaced entirely by
   .aap__mobile-list — see the 767px media query below. A horizontally
   scrolling table is a poor mobile pattern, so below 767px we swap to a
   stacked card list instead of just letting the table scroll sideways. */
.aap__table-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.aap__mobile-list {
  display: none;
}

.aap__table {
  width: 100%;
  border-collapse: collapse;
}

.aap__table th {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--admin-muted);
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--admin-border);
  text-align: left;
  background: #fafafa;
  white-space: nowrap;
}
.aap__th-check {
  width: 2.5rem;
}

.aap__table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
}
.aap__table tbody tr:last-child td {
  border-bottom: none;
}

.aap__row {
  cursor: pointer;
  transition: background 0.12s;
}
.aap__row:hover {
  background: #fafafa;
}
.aap__row--selected {
  background: rgba(var(--admin-rust-rgb), 0.04) !important;
}

.aap__td-check {
  width: 2.5rem;
}
.aap__checkbox {
  accent-color: var(--admin-rust);
  width: 1rem;
  height: 1rem;
  cursor: pointer;
}

.aap__applicant {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.aap__applicant-avatar {
  width: 2.1rem;
  height: 2.1rem;
  border-radius: 50%;
  color: #fff;
  font-size: 0.65rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  letter-spacing: 0.03em;
}
.aap__applicant-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--admin-text);
  margin: 0;
}
.aap__applicant-email {
  font-size: 0.72rem;
  color: var(--admin-muted);
  margin: 0;
}

.aap__category {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.82rem;
  color: var(--admin-text);
}
.aap__cat-icon {
  font-size: 0.85rem;
  color: var(--admin-muted);
  flex-shrink: 0;
}

.aap__submitted p {
  font-size: 0.82rem;
  color: var(--admin-text);
  margin: 0;
}
.aap__submitted-time {
  font-size: 0.72rem;
  color: var(--admin-muted) !important;
}

.aap__row-actions {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.aap__action-btn {
  padding: 0.35rem;
  font-size: 1rem;
}

/* Pagination */
.aap__pagination {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding: 0.85rem 1rem;
  border-top: 1px solid var(--admin-border);
}
.aap__pagination-info {
  font-size: 0.8rem;
  color: var(--admin-muted);
  flex: 1 1;
  white-space: nowrap;
}
.aap__pagination-pages {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.aap__page-btn {
  min-width: 1.9rem;
  height: 1.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--admin-border);
  border-radius: 6px;
  background: #fff;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--admin-text);
  cursor: pointer;
  transition: all 0.15s;
  padding: 0 0.4rem;
}
.aap__page-btn:hover:not(:disabled) {
  background: #f9fafb;
}
.aap__page-btn:disabled {
  opacity: 0.4;
  cursor: default;
}
.aap__page-btn--active {
  background: var(--admin-rust);
  border-color: var(--admin-rust);
  color: #fff;
  font-weight: 700;
}

.aap__page-size {
  appearance: none;
  padding: 0.4rem 1.8rem 0.4rem 0.75rem;
  border: 1px solid var(--admin-border);
  border-radius: 6px;
  background: #fff;
  font-size: 0.8rem;
  color: var(--admin-text);
  cursor: pointer;
}

/* Detail panel (legacy split-panel, kept for compat) */
.aap__detail {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: 10px;
  overflow: hidden;
  position: sticky;
  top: calc(var(--admin-topbar-h) + 1rem);
}

.aap__detail-head {
  display: flex;
  justify-content: flex-end;
  padding: 0.6rem 0.75rem 0;
}
.aap__detail-close {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  color: var(--admin-muted);
  padding: 0.3rem;
  border-radius: 4px;
  transition: all 0.15s;
}
.aap__detail-close:hover {
  background: #f3f4f6;
  color: var(--admin-text);
}

.aap__detail-user {
  display: flex;
  gap: 0.85rem;
  padding: 0.5rem 1rem 1rem;
  align-items: flex-start;
}
.aap__detail-avatar {
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 50%;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.aap__detail-name {
  font-size: 1rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0 0 0.25rem;
}
.aap__detail-meta {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.78rem;
  color: var(--admin-text);
  margin-bottom: 0.25rem;
}
.aap__detail-meta-icon {
  font-size: 0.8rem;
}
.aap__detail-email {
  font-size: 0.78rem;
  color: var(--admin-muted);
  margin: 0 0 0.1rem;
}
.aap__detail-date {
  font-size: 0.72rem;
  color: var(--admin-muted);
  margin: 0.35rem 0 0;
}

.aap__detail-tabs {
  display: flex;
  border-bottom: 1px solid var(--admin-border);
  padding: 0 1rem;
}
.aap__detail-tab {
  padding: 0.6rem 0.75rem;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--admin-muted);
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  transition: all 0.15s;
}
.aap__detail-tab:hover {
  color: var(--admin-text);
}
.aap__detail-tab--active {
  color: var(--admin-rust);
  border-bottom-color: var(--admin-rust);
  font-weight: 700;
}

.aap__detail-body {
  padding: 0.85rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

/* Accordion rows */
.aap__accordion {
  border-bottom: 1px solid var(--admin-border);
}
.aap__accordion-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.8rem 0;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--admin-text);
  text-align: left;
  transition: color 0.15s;
}
.aap__accordion-btn:hover {
  color: var(--admin-rust);
}
.aap__accordion-icon {
  font-size: 0.75rem;
  color: var(--admin-muted);
  flex-shrink: 0;
}

/* Status + notes */
.aap__status-section,
.aap__notes-section {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.aap__status-label {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
}
.aap__select {
  width: 100%;
}
.aap__notes-input {
  width: 100%;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  background: #f9fafb;
  padding: 0.75rem;
  font-size: 0.82rem;
  color: var(--admin-text);
  resize: vertical;
  outline: none;
  font-family: var(--font-body);
  transition: border-color 0.15s;
}
.aap__notes-input:focus {
  border-color: var(--admin-rust);
  background: #fff;
}
.aap__notes-input::placeholder {
  color: #9ca3af;
}

.aap__placeholder {
  font-size: 0.85rem;
  color: var(--admin-muted);
  text-align: center;
  padding: 2rem 0;
  margin: 0;
}

/* Responsive */
@media (max-width: 1199px) {
  .aap__stats-row {
    grid-template-columns: repeat(3, 1fr);
  }
  .aap__layout--detail {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 767px) {
  .aap__stats-row {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.6rem;
  }
  .aap__stat-card {
    padding: 0.9rem;
  }
  .aap__stat-icon {
    width: 1.9rem;
    height: 1.9rem;
  }
  .aap__stat-value {
    font-size: 1.4rem;
  }
  .aap__stat-label {
    font-size: 0.72rem;
    white-space: normal; /* allow 2-line wrap instead of clipping on narrow cards */
  }

  /* ── Filters: search full-width, then a clean 2-col grid for the rest ── */
  .aap__filters {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem;
    flex-wrap: unset;
  }
  .aap__search-wrap {
    grid-column: 1 / -1;
    min-width: 0;
  }
  .aap__select-wrap {
    min-width: 0;
  }
  .aap__filter-select {
    width: 100%;
    box-sizing: border-box;
  }
  .aap__date-wrap {
    grid-column: 1 / -1;
  }
  .aap__date-filter {
    width: 100%;
    box-sizing: border-box;
    justify-content: space-between;
  }
  .aap__email-btn {
    grid-column: 1 / -1;
    justify-content: center;
    width: 100%;
  }
  .aap__filter-extra-wrap {
    grid-column: 1 / -1;
  }
  .aap__filter-extra-wrap .aap__filter-btn {
    width: 100%;
    justify-content: center;
  }
  .aap__extra-filters {
    left: 0;
    right: 0;
    min-width: 0;
    max-width: none;
  }

  /* ── Table -> mobile card list swap ── */
  .aap__table-scroll {
    display: none;
  }
  .aap__mobile-list {
    display: flex;
    flex-direction: column;
  }
  .aap__mobile-selectall {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    font-size: 0.78rem;
    font-weight: 600;
    color: var(--admin-muted);
    border-bottom: 1px solid var(--admin-border);
    background: #fafafa;
  }
  .aap__mobile-card {
    padding: 0.9rem 1rem;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
    transition: background 0.12s;
  }
  .aap__mobile-card:active {
    background: #fafafa;
  }
  .aap__mobile-card--selected {
    background: rgba(var(--admin-rust-rgb), 0.04);
  }
  .aap__mobile-card-top {
    margin-bottom: 0.5rem;
  }
  .aap__mobile-card-main {
    display: flex;
    align-items: center;
    gap: 0.65rem;
  }
  .aap__mobile-card-info {
    flex: 1 1;
    min-width: 0;
  }
  .aap__mobile-card-info .aap__applicant-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .aap__mobile-card-info .aap__applicant-email {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .aap__mobile-card-meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    margin-top: 0.6rem;
    padding-top: 0.6rem;
    border-top: 1px solid #f5f2ee;
  }
  .aap__mobile-card-meta .aap__category {
    font-size: 0.76rem;
  }
  .aap__mobile-card-date {
    font-size: 0.72rem;
    color: var(--admin-muted);
  }

  /* ── Bulk action bar: clean 2-col wrap instead of loose wrapping ── */
  .abulk__bar {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .abulk__count,
  .abulk__label {
    flex-basis: 100%;
    text-align: center;
  }
  .abulk__status-btn {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 0.25rem);
    justify-content: center;
  }
  .abulk__btn {
    flex-basis: 100%;
    justify-content: center;
  }
  .aap__pagination {
    flex-direction: column;
    align-items: stretch;
  }
  .aap__pagination-info {
    order: 2;
    text-align: center;
  }
  .aap__pagination-pages {
    order: 1;
    justify-content: center;
  }
  .aap__page-size {
    order: 3;
    align-self: center;
  }
}
@media (max-width: 420px) {
  .aap__stats-row {
    grid-template-columns: 1fr;
  }
}

/* ── Full-screen viewer ── */
.aap__viewer {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - var(--admin-topbar-h));
  background: var(--admin-bg);
  margin: -2rem -2.5rem;
  padding: 0;
}

.aap__viewer-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.85rem 2rem;
  background: #fff;
  border-bottom: 1px solid var(--admin-border);
  position: sticky;
  top: var(--admin-topbar-h);
  z-index: 50;
  gap: 1rem;
  flex-wrap: wrap;
}

.aap__back-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--admin-text);
  padding: 0.4rem 0.6rem;
  border-radius: 6px;
  transition: background 0.15s;
}
.aap__back-btn:hover {
  background: #f3f4f0;
}

.aap__viewer-actions {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-wrap: wrap;
}

/* Keeps the status select + save button as one visual unit so they never
   split apart when the bar wraps on mid-size screens */
.aap__viewer-actions-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: nowrap;
}

.aap__viewer-status-select {
  appearance: none;
  padding: 0.55rem 2rem 0.55rem 0.85rem;
  border: 1px solid var(--admin-border);
  border-radius: 6px;
  background: #fff;
  font-size: 0.84rem;
  cursor: pointer;
  outline: none;
  min-width: 130px;
}
.aap__viewer-status-select:focus {
  border-color: var(--admin-rust);
}

.aap__viewer-content {
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 1.5rem;
  padding: 1.5rem 2rem;
  align-items: start;
  flex: 1 1;
}

.aap__viewer-header {
  display: flex;
  gap: 1.25rem;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.aap__viewer-avatar {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  letter-spacing: 0.03em;
}

.aap__viewer-name {
  font-family: var(--font-serif);
  font-size: 1.3rem;
  font-weight: 600;
  color: var(--admin-text);
  margin: 0 0 0.4rem;
}

.aap__viewer-meta-row {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
}
.aap__viewer-category {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.82rem;
  color: var(--admin-muted);
}

.aap__viewer-contact-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.85rem;
  margin-bottom: 0.4rem;
}
.aap__viewer-contact-row span {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.78rem;
  color: var(--admin-muted);
}
.aap__viewer-contact-row svg {
  font-size: 0.85rem;
  color: var(--admin-rust);
}

.aap__viewer-submitted {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.75rem;
  color: var(--admin-muted);
  margin: 0;
}
.aap__viewer-submitted svg {
  font-size: 0.85rem;
}

/* Tabs */
.aap__viewer-tabs {
  display: flex;
  gap: 0;
  border-bottom: 2px solid var(--admin-border);
  margin-bottom: 1rem;
}
.aap__viewer-tab {
  padding: 0.6rem 1rem;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 0.84rem;
  font-weight: 500;
  color: var(--admin-muted);
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all 0.15s;
}
.aap__viewer-tab:hover {
  color: var(--admin-text);
}
.aap__viewer-tab--active {
  color: var(--admin-rust);
  border-bottom-color: var(--admin-rust);
  font-weight: 700;
}

/* ── Safety flag banner — always visible, top of viewer regardless of tab ── */
.aap__safety-banner {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin: 0 2rem;
  padding: 0.85rem 1.1rem;
  background: rgba(220, 38, 38, 0.06);
  border: 1.5px solid rgba(220, 38, 38, 0.3);
  border-radius: 10px;
}
.aap__safety-banner-icon {
  font-size: 1.3rem;
  color: #dc2626;
  flex-shrink: 0;
  margin-top: 0.1rem;
}
.aap__safety-banner-body {
  flex: 1 1;
  min-width: 0;
}
.aap__safety-banner-title {
  font-size: 0.86rem;
  font-weight: 800;
  color: #dc2626;
  margin: 0 0 0.25rem;
}
.aap__safety-banner-text {
  font-size: 0.8rem;
  color: #7f1d1d;
  margin: 0;
  line-height: 1.55;
}

/* ── Workflow vs reference-data visual hierarchy ── */
.aap__workflow-card {
  border-left: 3px solid var(--admin-rust);
}
.aap__reference-card {
  /* plain card — no accent, reads as static/lower-priority relative to workflow */
}
.aap__workflow-card-title {
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--admin-rust);
  margin: 0 0 0.35rem;
}
.aap__workflow-card-title--muted {
  color: var(--admin-muted);
}

/* Section accordion */
.aap__section {
  border-bottom: 1px solid var(--admin-border);
}
.aap__section:last-child {
  border-bottom: none;
}

.aap__section-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.85rem 0;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--admin-text);
  text-align: left;
}
.aap__section-btn:hover {
  color: var(--admin-rust);
}
.aap__section-chevron {
  font-size: 0.85rem;
  color: var(--admin-muted);
  flex-shrink: 0;
}

.aap__section-body {
  padding-bottom: 1rem;
}

.aap__info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0.45rem 0;
  gap: 1rem;
  border-bottom: 1px solid #f0ebe4;
}
.aap__info-row:last-child {
  border-bottom: none;
}
.aap__info-label {
  font-size: 0.78rem;
  color: var(--admin-muted);
  flex-shrink: 0;
  min-width: 120px;
}
.aap__info-value {
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--admin-text);
  text-align: right;
  word-break: break-word;
}

/* Eligibility */
.aap__eligibility {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.aap__elig-item {
  padding: 0.75rem;
  background: #faf7f2;
  border-radius: 6px;
  border: 1px solid var(--admin-border);
}
.aap__elig-item--yes {
  background: rgba(220, 38, 38, 0.05);
  border-color: rgba(220, 38, 38, 0.25);
}
.aap__elig-q {
  font-size: 0.8rem;
  color: var(--admin-muted);
  margin: 0 0 0.3rem;
}
.aap__elig-a {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
}
.aap__elig-item--yes .aap__elig-a {
  color: #dc2626;
}

/* Story */
.aap__story-text {
  font-size: 0.88rem;
  color: var(--admin-text);
  line-height: 1.65;
  margin: 0;
}

/* Documents */
.aap__viewer-docs {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.aap__doc-card {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.85rem;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  background: #faf7f2;
}
.aap__doc-icon {
  font-size: 1.5rem;
  color: var(--admin-rust);
  flex-shrink: 0;
}
.aap__doc-info {
  flex: 1 1;
  min-width: 0;
}
.aap__doc-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--admin-text);
  margin: 0 0 0.15rem;
  overflow-wrap: break-word;
}
.aap__doc-type {
  font-size: 0.72rem;
  color: var(--admin-muted);
  margin: 0;
}

/* Notes */
.aap__viewer-notes {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.aap__note-card {
  display: flex;
  gap: 0.75rem;
  padding: 0.75rem;
  background: #faf7f2;
  border-radius: 6px;
}
.aap__note-avatar {
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  background: var(--admin-border);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  color: var(--admin-muted);
  flex-shrink: 0;
}
.aap__note-meta {
  font-size: 0.7rem;
  color: var(--admin-muted);
  margin: 0 0 0.25rem;
}
.aap__note-text {
  font-size: 0.84rem;
  color: var(--admin-text);
  margin: 0;
  line-height: 1.5;
}

/* Sidebar */
.aap__viewer-sidebar {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: sticky;
  top: calc(var(--admin-topbar-h) + 4.5rem);
  min-width: 0;
}
.aap__viewer-quick .aap__status-label {
  margin-bottom: 0.65rem;
  font-weight: 700;
}
.aap__quick-info-rows {
  display: flex;
  flex-direction: column;
}

/* ── Sidebar pipeline mini-progress ── */
.aap__sidebar-pipeline {
  margin: 0.85rem 0;
  padding: 0.75rem;
  background: var(--admin-surface);
  border-radius: 8px;
}
.aap__sidebar-pipeline-dots {
  display: flex;
  gap: 0.3rem;
  margin-bottom: 0.5rem;
}
.aap__sidebar-pipeline-dot {
  flex: 1 1;
  height: 5px;
  border-radius: 99px;
  background: var(--admin-border);
}
.aap__sidebar-pipeline-dot--done {
  background: #1e2a1e;
}
.aap__sidebar-pipeline-label {
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
  text-align: center;
}

/* Contact modal */
.aap__contact-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  box-sizing: border-box;
}
.aap__contact-modal {
  background: #fff;
  border-radius: 12px;
  padding: 1.75rem;
  width: min(420px, 90vw);
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);
}
.aap__contact-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
.aap__contact-head h3 {
  font-size: 1rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
}
.aap__contact-head button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.1rem;
  color: var(--admin-muted);
}
.aap__contact-name {
  font-size: 0.85rem;
  color: var(--admin-muted);
  margin: 0 0 1.25rem;
}
.aap__contact-option {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.85rem;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  text-decoration: none;
  margin-bottom: 0.65rem;
  transition: background 0.15s;
}
.aap__contact-option:hover {
  background: #faf7f2;
}
.aap__contact-icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  flex-shrink: 0;
}
.aap__contact-type {
  font-size: 0.72rem;
  color: var(--admin-muted);
  margin: 0 0 0.1rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
.aap__contact-detail {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--admin-text);
  margin: 0;
  overflow-wrap: break-word;
}

/* Date filter */
.aap__date-wrap {
  position: relative;
}
.aap__date-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  background: #fff;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  z-index: 100;
  min-width: 260px;
  max-width: calc(100vw - 2rem);
}
.aap__date-picker {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}
.aap__date-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}
.aap__date-field label {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--admin-muted);
}
.aap__date-field input {
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--admin-border);
  border-radius: 6px;
  font-size: 0.84rem;
  outline: none;
  color: var(--admin-text);
  box-sizing: border-box;
  width: 100%;
}
.aap__date-field input:focus {
  border-color: var(--admin-rust);
}

/* Extra filters panel */
.aap__filter-extra-wrap {
  position: relative;
}
.aap__extra-filters {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: #fff;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  z-index: 100;
  min-width: 220px;
  max-width: calc(100vw - 2rem);
}
.aap__extra-title {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--admin-muted);
  margin: 0 0 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}
.aap__extra-row {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 0.6rem;
}
.aap__extra-row label {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--admin-muted);
}
.aap__extra-row select {
  padding: 0.45rem 0.7rem;
  border: 1px solid var(--admin-border);
  border-radius: 6px;
  font-size: 0.82rem;
  outline: none;
  width: 100%;
  box-sizing: border-box;
}

/* Viewer main col sections card */
.aap__viewer-sections {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.aap__viewer-main {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
}

/* Stack sidebar earlier than full mobile — 320px sidebar next to a shrinking
   main column starts feeling cramped well before 1023px */
@media (max-width: 1180px) {
  .aap__viewer-content {
    grid-template-columns: 1fr;
  }
  .aap__viewer-sidebar {
    position: static;
  }
}

/* ── Bulk action bar (shared) ── */
.abulk__bar {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  flex-wrap: wrap;
  background: rgba(var(--admin-rust-rgb), 0.06);
  border: 1.5px solid rgba(var(--admin-rust-rgb), 0.25);
  border-radius: 8px;
  padding: 0.6rem 1rem;
  animation: slideDown 0.2s ease;
}

.abulk__count {
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--admin-rust);
  white-space: nowrap;
}

.abulk__label {
  font-size: 0.78rem;
  color: var(--admin-muted);
  white-space: nowrap;
}

.abulk__btn {
  font-size: 0.78rem !important;
  padding: 0.4rem 0.8rem !important;
  white-space: nowrap;
}

/* Bulk status buttons */
.abulk__status-btn {
  display: inline-flex;
  align-items: center;
  padding: 0.35rem 0.75rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 700;
  cursor: pointer;
  border: 1.5px solid;
  transition: all 0.15s;
  white-space: nowrap;
}
.abulk__status-btn:disabled {
  opacity: 0.5;
  cursor: wait;
}

.abulk__status-btn--reviewing {
  background: rgba(217, 119, 6, 0.1);
  border-color: rgba(217, 119, 6, 0.4);
  color: #d97706;
}
.abulk__status-btn--under-review {
  background: rgba(124, 58, 237, 0.1);
  border-color: rgba(124, 58, 237, 0.3);
  color: #7c3aed;
}
.abulk__status-btn--accepted {
  background: rgba(22, 163, 74, 0.1);
  border-color: rgba(22, 163, 74, 0.3);
  color: #16a34a;
}
.abulk__status-btn--rejected {
  background: rgba(220, 38, 38, 0.1);
  border-color: rgba(220, 38, 38, 0.3);
  color: #dc2626;
}

.abulk__status-btn:hover:not(:disabled) {
  filter: brightness(0.92);
}

/* ═══════════════════════════════════════════════════════════
   STORY SECTIONS — parsed labeled blocks
═══════════════════════════════════════════════════════════ */
.aap__story-sections {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}
.aap__story-section {
  border-left: 2px solid var(--admin-rust);
  padding: 0.5rem 0 0.5rem 0.85rem;
}
.aap__story-section-label {
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--admin-rust);
  margin: 0 0 0.4rem;
}
.aap__story-text {
  font-size: 0.88rem;
  color: var(--admin-text);
  line-height: 1.7;
  margin: 0;
  white-space: pre-wrap;
}

/* ═══════════════════════════════════════════════════════════
   DUAL NOTES PANEL
═══════════════════════════════════════════════════════════ */
.aap__notes-dual {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  align-items: start;
}

/* Two ~500px note panels side by side get cramped well before phone width —
   stack much earlier than the old 767px breakpoint */
@media (max-width: 980px) {
  .aap__notes-dual {
    grid-template-columns: 1fr;
  }
}

.aap__notes-panel {
  display: flex;
  flex-direction: column;
  gap: 0;
  overflow: hidden;
}

.aap__notes-panel-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.9rem 1rem;
  border-bottom: 1px solid var(--admin-border);
  flex-wrap: wrap;
}
.aap__notes-panel-title {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--admin-text);
}
.aap__notes-panel-icon {
  font-size: 0.95rem;
  flex-shrink: 0;
}
.aap__notes-panel-icon--internal {
  color: #6b6258;
}
.aap__notes-panel-icon--applicant {
  color: #16a34a;
}

.aap__notes-panel-badge {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 0.2rem 0.55rem;
  border-radius: 99px;
  white-space: nowrap;
}
.aap__notes-panel-badge--internal {
  background: rgba(107, 98, 88, 0.1);
  color: #6b6258;
}
.aap__notes-panel-badge--applicant {
  background: rgba(22, 163, 74, 0.1);
  color: #16a34a;
}

/* Note list */
.aap__notes-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  flex: 1 1;
}

.aap__note-card {
  display: flex;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid var(--admin-border);
  align-items: flex-start;
}
.aap__note-card:last-child {
  border-bottom: none;
}

.aap__note-avatar {
  width: 1.9rem;
  height: 1.9rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  flex-shrink: 0;
}
.aap__note-avatar--internal {
  background: rgba(107, 98, 88, 0.1);
  color: #6b6258;
}
.aap__note-avatar--applicant {
  background: rgba(22, 163, 74, 0.1);
  color: #16a34a;
}

.aap__note-body {
  flex: 1 1;
  min-width: 0;
}
.aap__note-meta {
  font-size: 0.72rem;
  color: var(--admin-muted);
  margin: 0 0 0.3rem;
}
.aap__note-text {
  font-size: 0.84rem;
  color: var(--admin-text);
  line-height: 1.6;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
}

/* Compose box */
.aap__notes-compose {
  padding: 0.85rem 1rem;
  border-top: 1px solid var(--admin-border);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background: #fafaf9;
}
.aap__notes-compose--applicant {
  background: rgba(22, 163, 74, 0.03);
}

.aap__notes-input {
  width: 100%;
  border: 1px solid var(--admin-border);
  border-radius: 7px;
  padding: 0.6rem 0.75rem;
  font-size: 0.84rem;
  font-family: inherit;
  color: var(--admin-text);
  resize: none;
  outline: none;
  transition: border-color 0.15s;
  background: #fff;
  box-sizing: border-box;
}
.aap__notes-input:focus {
  border-color: var(--admin-rust);
  box-shadow: 0 0 0 2px rgba(var(--admin-rust-rgb), 0.09);
}

.aap__notes-compose-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.aap__notes-hint {
  font-size: 0.67rem;
  color: var(--admin-muted);
}

.aap__notes-applicant-warn {
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
  font-size: 0.75rem;
  color: #15803d;
  background: rgba(22, 163, 74, 0.07);
  border: 1px solid rgba(22, 163, 74, 0.2);
  border-radius: 6px;
  padding: 0.55rem 0.7rem;
  line-height: 1.45;
}

/* ═══════════════════════════════════════════════════════════
   MOBILE RESPONSIVE — viewer
═══════════════════════════════════════════════════════════ */
@media (max-width: 767px) {
  /* Viewer takes full screen, no negative margin overflow */
  .aap__viewer {
    margin: -1rem -1rem 0;
  }

  /* Top bar stacks */
  .aap__viewer-bar {
    padding: 0.75rem 1rem;
    gap: 0.6rem;
  }
  .aap__viewer-actions {
    width: 100%;
    justify-content: flex-end;
    gap: 0.4rem;
    flex-wrap: wrap;
  }
  .aap__viewer-actions-group {
    width: 100%;
  }
  .aap__viewer-status-select {
    flex: 1 1;
    min-width: 0;
  }

  /* Safety banner: less side margin to match content padding */
  .aap__safety-banner {
    margin: 0 0.9rem;
  }

  /* Content: single column, no side padding */
  .aap__viewer-content {
    grid-template-columns: 1fr;
    padding: 0.85rem 0.9rem;
    gap: 0.85rem;
  }

  /* Header: avatar + info stack */
  .aap__viewer-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 1rem;
  }
  .aap__viewer-avatar {
    width: 3rem;
    height: 3rem;
    font-size: 1.1rem;
  }
  .aap__viewer-name {
    font-size: 1.1rem;
  }

  /* Tabs: scrollable if overflow */
  .aap__viewer-tabs {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 1px;
    flex-wrap: nowrap;
    scrollbar-width: none;
  }
  .aap__viewer-tabs::-webkit-scrollbar {
    display: none;
  }
  .aap__viewer-tab {
    white-space: nowrap;
    font-size: 0.78rem;
    padding: 0.65rem 0.85rem;
  }

  /* Info rows: stack label/value */
  .aap__info-row {
    flex-direction: column;
    gap: 0.15rem;
  }
  .aap__info-label {
    min-width: unset;
  }
  .aap__info-value {
    text-align: left;
  }

  /* Table: horizontal scroll */
  .aap__table-card {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .aap__table {
    min-width: 580px;
  }

  /* Filters: wrap, search takes full width first */
  .aap__filters {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .aap__search-wrap {
    width: 100%;
    min-width: 0;
    flex-basis: 100%;
  }

  /* Sidebar below main on mobile */
  .aap__viewer-sidebar {
    position: static;
  }
}

@media (max-width: 479px) {
  .aap__viewer-bar {
    padding: 0.65rem 0.75rem;
  }
  .aap__viewer-content {
    padding: 0.65rem 0.75rem;
  }
  .aap__safety-banner {
    margin: 0 0.75rem;
    padding: 0.75rem 0.85rem;
  }
  .aap__viewer-tab {
    padding: 0.55rem 0.65rem;
    font-size: 0.73rem;
  }
  .aap__notes-compose {
    padding: 0.65rem 0.75rem;
  }
  .aap__note-card {
    padding: 0.7rem 0.75rem;
  }
}

/* ── Ban / Unban buttons ── */
.aap__ban-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  padding: 0.6rem;
  border: 1.5px solid rgba(27, 27, 27, 0.25);
  border-radius: 7px;
  background: transparent;
  color: #1b1b1b;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s;
  margin-top: 0.25rem;
}
.aap__ban-btn:hover:not(:disabled) {
  background: rgba(27, 27, 27, 0.06);
  border-color: #1b1b1b;
}
.aap__ban-btn:disabled {
  opacity: 0.5;
  cursor: wait;
}

.aap__unban-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  padding: 0.6rem;
  border: 1.5px solid rgba(22, 163, 74, 0.35);
  border-radius: 7px;
  background: rgba(22, 163, 74, 0.06);
  color: #15803d;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s;
  margin-top: 0.25rem;
}
.aap__unban-btn:hover:not(:disabled) {
  background: rgba(22, 163, 74, 0.12);
}
.aap__unban-btn:disabled {
  opacity: 0.5;
  cursor: wait;
}

/* Banned status bulk button */
.abulk__status-btn--banned {
  background: rgba(27, 27, 27, 0.08);
  border-color: rgba(27, 27, 27, 0.3);
  color: #1b1b1b;
}
.abulk__status-btn--banned:hover:not(:disabled) {
  background: rgba(27, 27, 27, 0.14);
}

/* ── Applicant note replies (admin view) ── */
.aap__note-thread {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.aap__note-replies {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-left: 2.65rem;
  border-left: 2px solid rgba(184, 92, 56, 0.2);
}
.aap__note-reply {
  display: flex;
  gap: 0.6rem;
  align-items: flex-start;
  padding: 0.65rem 0.85rem;
  border-bottom: 1px solid var(--admin-border);
  background: rgba(184, 92, 56, 0.03);
}
.aap__note-reply:last-child {
  border-bottom: none;
}
.aap__note-reply-avatar {
  width: 1.7rem;
  height: 1.7rem;
  border-radius: 50%;
  flex-shrink: 0;
  background: #b85c38;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  font-weight: 800;
}
.aap__note-reply-body {
  flex: 1 1;
  min-width: 0;
}
.aap__note-reply-file {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-top: 0.35rem;
  font-size: 0.75rem;
  color: #b85c38;
  background: rgba(184, 92, 56, 0.08);
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
}
.aap__note-no-reply {
  font-size: 0.72rem;
  color: var(--admin-muted);
  font-style: italic;
  padding: 0.4rem 0.85rem 0.65rem 3.5rem;
}

@media (max-width: 767px) {
  .aap__note-replies {
    margin-left: 1.3rem;
  }
  .aap__note-no-reply {
    padding-left: 1.8rem;
  }
}

/* ── Documents tab — two-section layout ── */
.aap__docs-wrap {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.aap__docs-section-head {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid var(--admin-border);
  background: var(--admin-surface);
  flex-wrap: wrap;
}
.aap__docs-section-title {
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
  flex: 1 1;
}
.aap__docs-section-badge {
  font-size: 0.65rem;
  font-weight: 800;
  background: rgba(107, 98, 88, 0.12);
  color: var(--admin-muted);
  padding: 0.18rem 0.55rem;
  border-radius: 99px;
}
.aap__docs-section-badge--rust {
  background: rgba(184, 92, 56, 0.1);
  color: var(--admin-rust);
}

.aap__docs-section-sub {
  font-size: 0.75rem;
  color: var(--admin-muted);
  margin: 0;
  padding: 0.5rem 1rem 0;
  line-height: 1.5;
}

.aap__doc-icon--rust {
  color: var(--admin-rust) !important;
}

.aap__doc-note-ctx {
  font-style: italic;
  color: var(--admin-muted);
  font-size: 0.7rem;
}

@media (max-width: 479px) {
  .aap__doc-card {
    flex-wrap: wrap;
  }
}

/* ── Pipeline steps ── */
.aap__pipeline {
  display: flex;
  align-items: center;
  gap: 0.6rem 0;
  flex-wrap: wrap;
  margin-bottom: 0.85rem;
}
.aap__pipeline-step {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}
.aap__pipeline-step:not(:last-child)::after {
  content: "→";
  font-size: 0.7rem;
  color: var(--admin-muted);
  margin: 0 0.35rem;
}
.aap__pipeline-dot {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  border: 2px solid var(--admin-border);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--admin-muted);
  background: #fff;
  flex-shrink: 0;
}
.aap__pipeline-dot--done {
  background: #1e2a1e;
  border-color: #1e2a1e;
  color: #fff;
}
.aap__pipeline-label {
  font-size: 0.74rem;
  font-weight: 600;
  color: var(--admin-muted);
  white-space: nowrap;
}
.aap__pipeline-label--done {
  color: #1e2a1e;
}
.aap__pipeline-actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

/* On narrow screens, drop the arrow connectors and stack pipeline steps into
   a compact wrapped list instead — arrows orphaning at line-wraps looked broken */
@media (max-width: 560px) {
  .aap__pipeline {
    gap: 0.5rem 0.75rem;
  }
  .aap__pipeline-step:not(:last-child)::after {
    content: "";
    margin: 0;
  }
  .aap__pipeline-step {
    background: var(--admin-surface);
    padding: 0.3rem 0.55rem 0.3rem 0.3rem;
    border-radius: 99px;
  }
}

/* ── Prescreening Responses ── */
.aap__prescreening {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}
.aap__prescreening-date {
  font-size: 0.76rem;
  color: var(--admin-muted);
  margin: 0 0 0.25rem;
  padding-bottom: 0.6rem;
  border-bottom: 1px solid var(--admin-border);
}
.aap__prescreening-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.aap__prescreening-heading {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--admin-rust);
  margin: 0;
}
.aap__prescreening-row {
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--admin-border);
}
.aap__prescreening-row:last-child {
  border-bottom: none;
}
.aap__prescreening-q {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--admin-text);
  margin: 0 0 0.25rem;
  line-height: 1.5;
}
.aap__prescreening-a {
  font-size: 0.84rem;
  color: var(--admin-muted);
  margin: 0;
  line-height: 1.6;
  white-space: pre-wrap;
}

/* ── Medical Clearance status block ── */
.aap__medical-status {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.aap__medical-line {
  font-size: 0.85rem;
  color: var(--admin-text);
  margin: 0;
}
.aap__medical-line strong {
  color: var(--admin-text);
}
.aap__medical-hint {
  font-size: 0.75rem;
  color: var(--admin-muted);
  margin: 0.35rem 0 0;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/admin/AdminApplications.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B,oEAAoE;AACpE;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY,EAAE,kDAAkD;AAClE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;EAClC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;yEAGyE;AACzE;EACE,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;EAC5C,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wDAAwD;AAC1D;;AAEA;EACE,aAAa;AACf;AACA;EACE,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,SAAO;EACP,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;;EAEE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;EACvC;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,qCAAqC;IACrC,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,mBAAmB,EAAE,0DAA0D;EACjF;;EAEA,2EAA2E;EAC3E;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,sBAAsB;IACtB,8BAA8B;EAChC;EACA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,eAAe;EACjB;;EAEA,yCAAyC;EACzC;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,4CAA4C;IAC5C,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,gCAAgC;IAChC,eAAe;IACf,4BAA4B;EAC9B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,SAAO;IACP,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;EAC/B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA,sEAAsE;EACtE;IACE,aAAa;IACb,eAAe;IACf,WAAW;EACb;EACA;;IAEE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,YAA6B;IAA7B,cAA6B;IAA7B,+BAA6B;IAC7B,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,QAAQ;IACR,kBAAkB;EACpB;EACA;IACE,QAAQ;IACR,uBAAuB;EACzB;EACA;IACE,QAAQ;IACR,kBAAkB;EACpB;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,+CAA+C;EAC/C,2BAA2B;EAC3B,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;EAChB,0BAA0B;EAC1B,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;uDACuD;AACvD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,MAAM;EACN,4CAA4C;EAC5C,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA,sDAAsD;AACtD;EACE,wCAAwC;AAC1C;AACA;EACE,gFAAgF;AAClF;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,4CAA4C;AAC9C;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;AACX;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,yCAAyC;EACzC,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,+BAA+B;AACjC;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,YAAY;AACd;;AAEA;0DAC0D;AAC1D;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,6CAA6C;EAC7C,qDAAqD;EACrD,kBAAkB;EAClB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;6DAE6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,wCAAwC;EACxC,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA;;6DAE6D;AAC7D;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;qDACqD;AACrD;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;EACpB,4CAA4C;EAC5C,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,SAAO;AACT;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,4CAA4C;EAC5C,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,+BAA+B;EAC/B,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;6DAE6D;AAC7D;EACE,0DAA0D;EAC1D;IACE,qBAAqB;EACvB;;EAEA,mBAAmB;EACnB;IACE,qBAAqB;IACrB,WAAW;EACb;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,SAAO;IACP,YAAY;EACd;;EAEA,6DAA6D;EAC7D;IACE,gBAAgB;EAClB;;EAEA,4CAA4C;EAC5C;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,YAAY;EACd;;EAEA,gCAAgC;EAChC;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;;EAEA,iCAAiC;EACjC;IACE,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA,iCAAiC;EACjC;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;;EAEA,6BAA6B;EAC7B;IACE,gBAAgB;IAChB,iCAAiC;EACnC;EACA;IACE,gBAAgB;EAClB;;EAEA,iDAAiD;EACjD;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA,iCAAiC;EACjC;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;EACA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,kCAAkC;EAClC,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,kCAAkC;AACpC;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,oBAAoB;EACpB,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,4CAA4C;EAC5C,mCAAmC;AACrC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,mCAAmC;EACnC,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,4CAA4C;EAC5C,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,SAAO;AACT;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;kFACkF;AAClF;EACE;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,gCAAgC;IAChC,qCAAqC;IACrC,mBAAmB;EACrB;AACF;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,4CAA4C;AAC9C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/* ── Admin Applications ── */\n\n/* Stat row — 5 cards, with a real progression down to phone width */\n.aap__stats-row {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 0.85rem;\n}\n\n.aap__stat-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  min-width: 0; /* allow grid items to shrink below content size */\n}\n\n.aap__stat-top {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n.aap__stat-icon {\n  width: 2.2rem;\n  height: 2.2rem;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.aap__stat-label {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--admin-muted);\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.aap__stat-value {\n  font-family: var(--font-body);\n  font-size: 1.7rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n}\n.aap__stat-change {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  margin: 0;\n}\n.aap__stat-change.up {\n  color: var(--admin-green);\n}\n.aap__stat-change.down {\n  color: var(--admin-red);\n}\n\n/* Main layout: table + optional detail */\n.aap__layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n}\n.aap__layout--detail {\n  grid-template-columns: 1fr 340px;\n  align-items: start;\n}\n\n/* Filters */\n.aap__filters {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-bottom: 0.75rem;\n}\n\n.aap__search-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1;\n  min-width: 160px;\n}\n.aap__search-icon {\n  position: absolute;\n  left: 0.75rem;\n  font-size: 0.9rem;\n  color: var(--admin-muted);\n  pointer-events: none;\n}\n.aap__search {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.6rem 0.9rem 0.6rem 2.25rem;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  background: #fff;\n  font-size: 0.84rem;\n  color: var(--admin-text);\n  outline: none;\n  transition: border-color 0.15s;\n}\n.aap__search:focus {\n  border-color: var(--admin-rust);\n}\n.aap__search::placeholder {\n  color: #9ca3af;\n}\n\n.aap__select-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.aap__filter-select,\n.aap__select {\n  appearance: none;\n  -webkit-appearance: none;\n  padding: 0.6rem 2rem 0.6rem 0.9rem;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  background: #fff;\n  font-size: 0.84rem;\n  color: var(--admin-text);\n  cursor: pointer;\n  outline: none;\n  transition: border-color 0.15s;\n  max-width: 100%;\n}\n.aap__filter-select:focus,\n.aap__select:focus {\n  border-color: var(--admin-rust);\n}\n.aap__select-icon {\n  position: absolute;\n  right: 0.6rem;\n  font-size: 0.75rem;\n  color: var(--admin-muted);\n  pointer-events: none;\n}\n\n.aap__date-filter {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 0.9rem;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  background: #fff;\n  font-size: 0.84rem;\n  color: var(--admin-text);\n  cursor: pointer;\n  white-space: nowrap;\n}\n.aap__date-icon {\n  font-size: 0.9rem;\n  color: var(--admin-muted);\n}\n\n.aap__filters-right {\n  margin-left: auto;\n}\n.aap__filter-btn {\n  white-space: nowrap;\n}\n\n/* Table card */\n.aap__table-card {\n  padding: 0;\n  overflow: hidden;\n}\n\n/* Desktop/tablet: scrollable table wrapper. Mobile: replaced entirely by\n   .aap__mobile-list — see the 767px media query below. A horizontally\n   scrolling table is a poor mobile pattern, so below 767px we swap to a\n   stacked card list instead of just letting the table scroll sideways. */\n.aap__table-scroll {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.aap__mobile-list {\n  display: none;\n}\n\n.aap__table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.aap__table th {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--admin-muted);\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--admin-border);\n  text-align: left;\n  background: #fafafa;\n  white-space: nowrap;\n}\n.aap__th-check {\n  width: 2.5rem;\n}\n\n.aap__table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f0f0f0;\n  vertical-align: middle;\n}\n.aap__table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.aap__row {\n  cursor: pointer;\n  transition: background 0.12s;\n}\n.aap__row:hover {\n  background: #fafafa;\n}\n.aap__row--selected {\n  background: rgba(var(--admin-rust-rgb), 0.04) !important;\n}\n\n.aap__td-check {\n  width: 2.5rem;\n}\n.aap__checkbox {\n  accent-color: var(--admin-rust);\n  width: 1rem;\n  height: 1rem;\n  cursor: pointer;\n}\n\n.aap__applicant {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n.aap__applicant-avatar {\n  width: 2.1rem;\n  height: 2.1rem;\n  border-radius: 50%;\n  color: #fff;\n  font-size: 0.65rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  letter-spacing: 0.03em;\n}\n.aap__applicant-name {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--admin-text);\n  margin: 0;\n}\n.aap__applicant-email {\n  font-size: 0.72rem;\n  color: var(--admin-muted);\n  margin: 0;\n}\n\n.aap__category {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.82rem;\n  color: var(--admin-text);\n}\n.aap__cat-icon {\n  font-size: 0.85rem;\n  color: var(--admin-muted);\n  flex-shrink: 0;\n}\n\n.aap__submitted p {\n  font-size: 0.82rem;\n  color: var(--admin-text);\n  margin: 0;\n}\n.aap__submitted-time {\n  font-size: 0.72rem;\n  color: var(--admin-muted) !important;\n}\n\n.aap__row-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n.aap__action-btn {\n  padding: 0.35rem;\n  font-size: 1rem;\n}\n\n/* Pagination */\n.aap__pagination {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  padding: 0.85rem 1rem;\n  border-top: 1px solid var(--admin-border);\n}\n.aap__pagination-info {\n  font-size: 0.8rem;\n  color: var(--admin-muted);\n  flex: 1;\n  white-space: nowrap;\n}\n.aap__pagination-pages {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n.aap__page-btn {\n  min-width: 1.9rem;\n  height: 1.9rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--admin-border);\n  border-radius: 6px;\n  background: #fff;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--admin-text);\n  cursor: pointer;\n  transition: all 0.15s;\n  padding: 0 0.4rem;\n}\n.aap__page-btn:hover:not(:disabled) {\n  background: #f9fafb;\n}\n.aap__page-btn:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n.aap__page-btn--active {\n  background: var(--admin-rust);\n  border-color: var(--admin-rust);\n  color: #fff;\n  font-weight: 700;\n}\n\n.aap__page-size {\n  appearance: none;\n  padding: 0.4rem 1.8rem 0.4rem 0.75rem;\n  border: 1px solid var(--admin-border);\n  border-radius: 6px;\n  background: #fff;\n  font-size: 0.8rem;\n  color: var(--admin-text);\n  cursor: pointer;\n}\n\n/* Detail panel (legacy split-panel, kept for compat) */\n.aap__detail {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: 10px;\n  overflow: hidden;\n  position: sticky;\n  top: calc(var(--admin-topbar-h) + 1rem);\n}\n\n.aap__detail-head {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0.6rem 0.75rem 0;\n}\n.aap__detail-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1rem;\n  color: var(--admin-muted);\n  padding: 0.3rem;\n  border-radius: 4px;\n  transition: all 0.15s;\n}\n.aap__detail-close:hover {\n  background: #f3f4f6;\n  color: var(--admin-text);\n}\n\n.aap__detail-user {\n  display: flex;\n  gap: 0.85rem;\n  padding: 0.5rem 1rem 1rem;\n  align-items: flex-start;\n}\n.aap__detail-avatar {\n  width: 2.6rem;\n  height: 2.6rem;\n  border-radius: 50%;\n  color: #fff;\n  font-size: 0.75rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.aap__detail-name {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0 0 0.25rem;\n}\n.aap__detail-meta {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.78rem;\n  color: var(--admin-text);\n  margin-bottom: 0.25rem;\n}\n.aap__detail-meta-icon {\n  font-size: 0.8rem;\n}\n.aap__detail-email {\n  font-size: 0.78rem;\n  color: var(--admin-muted);\n  margin: 0 0 0.1rem;\n}\n.aap__detail-date {\n  font-size: 0.72rem;\n  color: var(--admin-muted);\n  margin: 0.35rem 0 0;\n}\n\n.aap__detail-tabs {\n  display: flex;\n  border-bottom: 1px solid var(--admin-border);\n  padding: 0 1rem;\n}\n.aap__detail-tab {\n  padding: 0.6rem 0.75rem;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: var(--admin-muted);\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  transition: all 0.15s;\n}\n.aap__detail-tab:hover {\n  color: var(--admin-text);\n}\n.aap__detail-tab--active {\n  color: var(--admin-rust);\n  border-bottom-color: var(--admin-rust);\n  font-weight: 700;\n}\n\n.aap__detail-body {\n  padding: 0.85rem 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n/* Accordion rows */\n.aap__accordion {\n  border-bottom: 1px solid var(--admin-border);\n}\n.aap__accordion-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.8rem 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--admin-text);\n  text-align: left;\n  transition: color 0.15s;\n}\n.aap__accordion-btn:hover {\n  color: var(--admin-rust);\n}\n.aap__accordion-icon {\n  font-size: 0.75rem;\n  color: var(--admin-muted);\n  flex-shrink: 0;\n}\n\n/* Status + notes */\n.aap__status-section,\n.aap__notes-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n.aap__status-label {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n}\n.aap__select {\n  width: 100%;\n}\n.aap__notes-input {\n  width: 100%;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  background: #f9fafb;\n  padding: 0.75rem;\n  font-size: 0.82rem;\n  color: var(--admin-text);\n  resize: vertical;\n  outline: none;\n  font-family: var(--font-body);\n  transition: border-color 0.15s;\n}\n.aap__notes-input:focus {\n  border-color: var(--admin-rust);\n  background: #fff;\n}\n.aap__notes-input::placeholder {\n  color: #9ca3af;\n}\n\n.aap__placeholder {\n  font-size: 0.85rem;\n  color: var(--admin-muted);\n  text-align: center;\n  padding: 2rem 0;\n  margin: 0;\n}\n\n/* Responsive */\n@media (max-width: 1199px) {\n  .aap__stats-row {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .aap__layout--detail {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 767px) {\n  .aap__stats-row {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.6rem;\n  }\n  .aap__stat-card {\n    padding: 0.9rem;\n  }\n  .aap__stat-icon {\n    width: 1.9rem;\n    height: 1.9rem;\n  }\n  .aap__stat-value {\n    font-size: 1.4rem;\n  }\n  .aap__stat-label {\n    font-size: 0.72rem;\n    white-space: normal; /* allow 2-line wrap instead of clipping on narrow cards */\n  }\n\n  /* ── Filters: search full-width, then a clean 2-col grid for the rest ── */\n  .aap__filters {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 0.5rem;\n    flex-wrap: unset;\n  }\n  .aap__search-wrap {\n    grid-column: 1 / -1;\n    min-width: 0;\n  }\n  .aap__select-wrap {\n    min-width: 0;\n  }\n  .aap__filter-select {\n    width: 100%;\n    box-sizing: border-box;\n  }\n  .aap__date-wrap {\n    grid-column: 1 / -1;\n  }\n  .aap__date-filter {\n    width: 100%;\n    box-sizing: border-box;\n    justify-content: space-between;\n  }\n  .aap__email-btn {\n    grid-column: 1 / -1;\n    justify-content: center;\n    width: 100%;\n  }\n  .aap__filter-extra-wrap {\n    grid-column: 1 / -1;\n  }\n  .aap__filter-extra-wrap .aap__filter-btn {\n    width: 100%;\n    justify-content: center;\n  }\n  .aap__extra-filters {\n    left: 0;\n    right: 0;\n    min-width: 0;\n    max-width: none;\n  }\n\n  /* ── Table -> mobile card list swap ── */\n  .aap__table-scroll {\n    display: none;\n  }\n  .aap__mobile-list {\n    display: flex;\n    flex-direction: column;\n  }\n  .aap__mobile-selectall {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: var(--admin-muted);\n    border-bottom: 1px solid var(--admin-border);\n    background: #fafafa;\n  }\n  .aap__mobile-card {\n    padding: 0.9rem 1rem;\n    border-bottom: 1px solid #f0f0f0;\n    cursor: pointer;\n    transition: background 0.12s;\n  }\n  .aap__mobile-card:active {\n    background: #fafafa;\n  }\n  .aap__mobile-card--selected {\n    background: rgba(var(--admin-rust-rgb), 0.04);\n  }\n  .aap__mobile-card-top {\n    margin-bottom: 0.5rem;\n  }\n  .aap__mobile-card-main {\n    display: flex;\n    align-items: center;\n    gap: 0.65rem;\n  }\n  .aap__mobile-card-info {\n    flex: 1;\n    min-width: 0;\n  }\n  .aap__mobile-card-info .aap__applicant-name {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .aap__mobile-card-info .aap__applicant-email {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .aap__mobile-card-meta {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.5rem;\n    margin-top: 0.6rem;\n    padding-top: 0.6rem;\n    border-top: 1px solid #f5f2ee;\n  }\n  .aap__mobile-card-meta .aap__category {\n    font-size: 0.76rem;\n  }\n  .aap__mobile-card-date {\n    font-size: 0.72rem;\n    color: var(--admin-muted);\n  }\n\n  /* ── Bulk action bar: clean 2-col wrap instead of loose wrapping ── */\n  .abulk__bar {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n  .abulk__count,\n  .abulk__label {\n    flex-basis: 100%;\n    text-align: center;\n  }\n  .abulk__status-btn {\n    flex: 1 1 calc(50% - 0.25rem);\n    justify-content: center;\n  }\n  .abulk__btn {\n    flex-basis: 100%;\n    justify-content: center;\n  }\n  .aap__pagination {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .aap__pagination-info {\n    order: 2;\n    text-align: center;\n  }\n  .aap__pagination-pages {\n    order: 1;\n    justify-content: center;\n  }\n  .aap__page-size {\n    order: 3;\n    align-self: center;\n  }\n}\n@media (max-width: 420px) {\n  .aap__stats-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ── Full-screen viewer ── */\n.aap__viewer {\n  display: flex;\n  flex-direction: column;\n  min-height: calc(100vh - var(--admin-topbar-h));\n  background: var(--admin-bg);\n  margin: -2rem -2.5rem;\n  padding: 0;\n}\n\n.aap__viewer-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.85rem 2rem;\n  background: #fff;\n  border-bottom: 1px solid var(--admin-border);\n  position: sticky;\n  top: var(--admin-topbar-h);\n  z-index: 50;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.aap__back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--admin-text);\n  padding: 0.4rem 0.6rem;\n  border-radius: 6px;\n  transition: background 0.15s;\n}\n.aap__back-btn:hover {\n  background: #f3f4f0;\n}\n\n.aap__viewer-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  flex-wrap: wrap;\n}\n\n/* Keeps the status select + save button as one visual unit so they never\n   split apart when the bar wraps on mid-size screens */\n.aap__viewer-actions-group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: nowrap;\n}\n\n.aap__viewer-status-select {\n  appearance: none;\n  padding: 0.55rem 2rem 0.55rem 0.85rem;\n  border: 1px solid var(--admin-border);\n  border-radius: 6px;\n  background: #fff;\n  font-size: 0.84rem;\n  cursor: pointer;\n  outline: none;\n  min-width: 130px;\n}\n.aap__viewer-status-select:focus {\n  border-color: var(--admin-rust);\n}\n\n.aap__viewer-content {\n  display: grid;\n  grid-template-columns: 1fr 320px;\n  gap: 1.5rem;\n  padding: 1.5rem 2rem;\n  align-items: start;\n  flex: 1;\n}\n\n.aap__viewer-header {\n  display: flex;\n  gap: 1.25rem;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n\n.aap__viewer-avatar {\n  width: 3.5rem;\n  height: 3.5rem;\n  border-radius: 50%;\n  color: #fff;\n  font-size: 1.1rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  letter-spacing: 0.03em;\n}\n\n.aap__viewer-name {\n  font-family: var(--font-serif);\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: var(--admin-text);\n  margin: 0 0 0.4rem;\n}\n\n.aap__viewer-meta-row {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  margin-bottom: 0.5rem;\n  flex-wrap: wrap;\n}\n.aap__viewer-category {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.82rem;\n  color: var(--admin-muted);\n}\n\n.aap__viewer-contact-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.85rem;\n  margin-bottom: 0.4rem;\n}\n.aap__viewer-contact-row span {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.78rem;\n  color: var(--admin-muted);\n}\n.aap__viewer-contact-row svg {\n  font-size: 0.85rem;\n  color: var(--admin-rust);\n}\n\n.aap__viewer-submitted {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.75rem;\n  color: var(--admin-muted);\n  margin: 0;\n}\n.aap__viewer-submitted svg {\n  font-size: 0.85rem;\n}\n\n/* Tabs */\n.aap__viewer-tabs {\n  display: flex;\n  gap: 0;\n  border-bottom: 2px solid var(--admin-border);\n  margin-bottom: 1rem;\n}\n.aap__viewer-tab {\n  padding: 0.6rem 1rem;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: 0.84rem;\n  font-weight: 500;\n  color: var(--admin-muted);\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  transition: all 0.15s;\n}\n.aap__viewer-tab:hover {\n  color: var(--admin-text);\n}\n.aap__viewer-tab--active {\n  color: var(--admin-rust);\n  border-bottom-color: var(--admin-rust);\n  font-weight: 700;\n}\n\n/* ── Safety flag banner — always visible, top of viewer regardless of tab ── */\n.aap__safety-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  margin: 0 2rem;\n  padding: 0.85rem 1.1rem;\n  background: rgba(220, 38, 38, 0.06);\n  border: 1.5px solid rgba(220, 38, 38, 0.3);\n  border-radius: 10px;\n}\n.aap__safety-banner-icon {\n  font-size: 1.3rem;\n  color: #dc2626;\n  flex-shrink: 0;\n  margin-top: 0.1rem;\n}\n.aap__safety-banner-body {\n  flex: 1;\n  min-width: 0;\n}\n.aap__safety-banner-title {\n  font-size: 0.86rem;\n  font-weight: 800;\n  color: #dc2626;\n  margin: 0 0 0.25rem;\n}\n.aap__safety-banner-text {\n  font-size: 0.8rem;\n  color: #7f1d1d;\n  margin: 0;\n  line-height: 1.55;\n}\n\n/* ── Workflow vs reference-data visual hierarchy ── */\n.aap__workflow-card {\n  border-left: 3px solid var(--admin-rust);\n}\n.aap__reference-card {\n  /* plain card — no accent, reads as static/lower-priority relative to workflow */\n}\n.aap__workflow-card-title {\n  font-size: 0.7rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--admin-rust);\n  margin: 0 0 0.35rem;\n}\n.aap__workflow-card-title--muted {\n  color: var(--admin-muted);\n}\n\n/* Section accordion */\n.aap__section {\n  border-bottom: 1px solid var(--admin-border);\n}\n.aap__section:last-child {\n  border-bottom: none;\n}\n\n.aap__section-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.85rem 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  text-align: left;\n}\n.aap__section-btn:hover {\n  color: var(--admin-rust);\n}\n.aap__section-chevron {\n  font-size: 0.85rem;\n  color: var(--admin-muted);\n  flex-shrink: 0;\n}\n\n.aap__section-body {\n  padding-bottom: 1rem;\n}\n\n.aap__info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 0.45rem 0;\n  gap: 1rem;\n  border-bottom: 1px solid #f0ebe4;\n}\n.aap__info-row:last-child {\n  border-bottom: none;\n}\n.aap__info-label {\n  font-size: 0.78rem;\n  color: var(--admin-muted);\n  flex-shrink: 0;\n  min-width: 120px;\n}\n.aap__info-value {\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: var(--admin-text);\n  text-align: right;\n  word-break: break-word;\n}\n\n/* Eligibility */\n.aap__eligibility {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n.aap__elig-item {\n  padding: 0.75rem;\n  background: #faf7f2;\n  border-radius: 6px;\n  border: 1px solid var(--admin-border);\n}\n.aap__elig-item--yes {\n  background: rgba(220, 38, 38, 0.05);\n  border-color: rgba(220, 38, 38, 0.25);\n}\n.aap__elig-q {\n  font-size: 0.8rem;\n  color: var(--admin-muted);\n  margin: 0 0 0.3rem;\n}\n.aap__elig-a {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n}\n.aap__elig-item--yes .aap__elig-a {\n  color: #dc2626;\n}\n\n/* Story */\n.aap__story-text {\n  font-size: 0.88rem;\n  color: var(--admin-text);\n  line-height: 1.65;\n  margin: 0;\n}\n\n/* Documents */\n.aap__viewer-docs {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n.aap__doc-card {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 0.85rem;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  background: #faf7f2;\n}\n.aap__doc-icon {\n  font-size: 1.5rem;\n  color: var(--admin-rust);\n  flex-shrink: 0;\n}\n.aap__doc-info {\n  flex: 1;\n  min-width: 0;\n}\n.aap__doc-name {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--admin-text);\n  margin: 0 0 0.15rem;\n  overflow-wrap: break-word;\n}\n.aap__doc-type {\n  font-size: 0.72rem;\n  color: var(--admin-muted);\n  margin: 0;\n}\n\n/* Notes */\n.aap__viewer-notes {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n.aap__note-card {\n  display: flex;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  background: #faf7f2;\n  border-radius: 6px;\n}\n.aap__note-avatar {\n  width: 1.75rem;\n  height: 1.75rem;\n  border-radius: 50%;\n  background: var(--admin-border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.85rem;\n  color: var(--admin-muted);\n  flex-shrink: 0;\n}\n.aap__note-meta {\n  font-size: 0.7rem;\n  color: var(--admin-muted);\n  margin: 0 0 0.25rem;\n}\n.aap__note-text {\n  font-size: 0.84rem;\n  color: var(--admin-text);\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Sidebar */\n.aap__viewer-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  position: sticky;\n  top: calc(var(--admin-topbar-h) + 4.5rem);\n  min-width: 0;\n}\n.aap__viewer-quick .aap__status-label {\n  margin-bottom: 0.65rem;\n  font-weight: 700;\n}\n.aap__quick-info-rows {\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── Sidebar pipeline mini-progress ── */\n.aap__sidebar-pipeline {\n  margin: 0.85rem 0;\n  padding: 0.75rem;\n  background: var(--admin-surface);\n  border-radius: 8px;\n}\n.aap__sidebar-pipeline-dots {\n  display: flex;\n  gap: 0.3rem;\n  margin-bottom: 0.5rem;\n}\n.aap__sidebar-pipeline-dot {\n  flex: 1;\n  height: 5px;\n  border-radius: 99px;\n  background: var(--admin-border);\n}\n.aap__sidebar-pipeline-dot--done {\n  background: #1e2a1e;\n}\n.aap__sidebar-pipeline-label {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n  text-align: center;\n}\n\n/* Contact modal */\n.aap__contact-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n.aap__contact-modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 1.75rem;\n  width: min(420px, 90vw);\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);\n}\n.aap__contact-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.5rem;\n}\n.aap__contact-head h3 {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n}\n.aap__contact-head button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1.1rem;\n  color: var(--admin-muted);\n}\n.aap__contact-name {\n  font-size: 0.85rem;\n  color: var(--admin-muted);\n  margin: 0 0 1.25rem;\n}\n.aap__contact-option {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 0.85rem;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  text-decoration: none;\n  margin-bottom: 0.65rem;\n  transition: background 0.15s;\n}\n.aap__contact-option:hover {\n  background: #faf7f2;\n}\n.aap__contact-icon {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n  flex-shrink: 0;\n}\n.aap__contact-type {\n  font-size: 0.72rem;\n  color: var(--admin-muted);\n  margin: 0 0 0.1rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n.aap__contact-detail {\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--admin-text);\n  margin: 0;\n  overflow-wrap: break-word;\n}\n\n/* Date filter */\n.aap__date-wrap {\n  position: relative;\n}\n.aap__date-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  background: #fff;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  padding: 1rem;\n  z-index: 100;\n  min-width: 260px;\n  max-width: calc(100vw - 2rem);\n}\n.aap__date-picker {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n.aap__date-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n.aap__date-field label {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--admin-muted);\n}\n.aap__date-field input {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid var(--admin-border);\n  border-radius: 6px;\n  font-size: 0.84rem;\n  outline: none;\n  color: var(--admin-text);\n  box-sizing: border-box;\n  width: 100%;\n}\n.aap__date-field input:focus {\n  border-color: var(--admin-rust);\n}\n\n/* Extra filters panel */\n.aap__filter-extra-wrap {\n  position: relative;\n}\n.aap__extra-filters {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  background: #fff;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  padding: 1rem;\n  z-index: 100;\n  min-width: 220px;\n  max-width: calc(100vw - 2rem);\n}\n.aap__extra-title {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--admin-muted);\n  margin: 0 0 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n}\n.aap__extra-row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  margin-bottom: 0.6rem;\n}\n.aap__extra-row label {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--admin-muted);\n}\n.aap__extra-row select {\n  padding: 0.45rem 0.7rem;\n  border: 1px solid var(--admin-border);\n  border-radius: 6px;\n  font-size: 0.82rem;\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Viewer main col sections card */\n.aap__viewer-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n.aap__viewer-main {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  min-width: 0;\n}\n\n/* Stack sidebar earlier than full mobile — 320px sidebar next to a shrinking\n   main column starts feeling cramped well before 1023px */\n@media (max-width: 1180px) {\n  .aap__viewer-content {\n    grid-template-columns: 1fr;\n  }\n  .aap__viewer-sidebar {\n    position: static;\n  }\n}\n\n/* ── Bulk action bar (shared) ── */\n.abulk__bar {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  flex-wrap: wrap;\n  background: rgba(var(--admin-rust-rgb), 0.06);\n  border: 1.5px solid rgba(var(--admin-rust-rgb), 0.25);\n  border-radius: 8px;\n  padding: 0.6rem 1rem;\n  animation: slideDown 0.2s ease;\n}\n\n.abulk__count {\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: var(--admin-rust);\n  white-space: nowrap;\n}\n\n.abulk__label {\n  font-size: 0.78rem;\n  color: var(--admin-muted);\n  white-space: nowrap;\n}\n\n.abulk__btn {\n  font-size: 0.78rem !important;\n  padding: 0.4rem 0.8rem !important;\n  white-space: nowrap;\n}\n\n/* Bulk status buttons */\n.abulk__status-btn {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.35rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  cursor: pointer;\n  border: 1.5px solid;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n.abulk__status-btn:disabled {\n  opacity: 0.5;\n  cursor: wait;\n}\n\n.abulk__status-btn--reviewing {\n  background: rgba(217, 119, 6, 0.1);\n  border-color: rgba(217, 119, 6, 0.4);\n  color: #d97706;\n}\n.abulk__status-btn--under-review {\n  background: rgba(124, 58, 237, 0.1);\n  border-color: rgba(124, 58, 237, 0.3);\n  color: #7c3aed;\n}\n.abulk__status-btn--accepted {\n  background: rgba(22, 163, 74, 0.1);\n  border-color: rgba(22, 163, 74, 0.3);\n  color: #16a34a;\n}\n.abulk__status-btn--rejected {\n  background: rgba(220, 38, 38, 0.1);\n  border-color: rgba(220, 38, 38, 0.3);\n  color: #dc2626;\n}\n\n.abulk__status-btn:hover:not(:disabled) {\n  filter: brightness(0.92);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   STORY SECTIONS — parsed labeled blocks\n═══════════════════════════════════════════════════════════ */\n.aap__story-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 1.1rem;\n}\n.aap__story-section {\n  border-left: 2px solid var(--admin-rust);\n  padding: 0.5rem 0 0.5rem 0.85rem;\n}\n.aap__story-section-label {\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--admin-rust);\n  margin: 0 0 0.4rem;\n}\n.aap__story-text {\n  font-size: 0.88rem;\n  color: var(--admin-text);\n  line-height: 1.7;\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   DUAL NOTES PANEL\n═══════════════════════════════════════════════════════════ */\n.aap__notes-dual {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  align-items: start;\n}\n\n/* Two ~500px note panels side by side get cramped well before phone width —\n   stack much earlier than the old 767px breakpoint */\n@media (max-width: 980px) {\n  .aap__notes-dual {\n    grid-template-columns: 1fr;\n  }\n}\n\n.aap__notes-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  overflow: hidden;\n}\n\n.aap__notes-panel-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid var(--admin-border);\n  flex-wrap: wrap;\n}\n.aap__notes-panel-title {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: var(--admin-text);\n}\n.aap__notes-panel-icon {\n  font-size: 0.95rem;\n  flex-shrink: 0;\n}\n.aap__notes-panel-icon--internal {\n  color: #6b6258;\n}\n.aap__notes-panel-icon--applicant {\n  color: #16a34a;\n}\n\n.aap__notes-panel-badge {\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  padding: 0.2rem 0.55rem;\n  border-radius: 99px;\n  white-space: nowrap;\n}\n.aap__notes-panel-badge--internal {\n  background: rgba(107, 98, 88, 0.1);\n  color: #6b6258;\n}\n.aap__notes-panel-badge--applicant {\n  background: rgba(22, 163, 74, 0.1);\n  color: #16a34a;\n}\n\n/* Note list */\n.aap__notes-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  flex: 1;\n}\n\n.aap__note-card {\n  display: flex;\n  gap: 0.75rem;\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid var(--admin-border);\n  align-items: flex-start;\n}\n.aap__note-card:last-child {\n  border-bottom: none;\n}\n\n.aap__note-avatar {\n  width: 1.9rem;\n  height: 1.9rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.85rem;\n  flex-shrink: 0;\n}\n.aap__note-avatar--internal {\n  background: rgba(107, 98, 88, 0.1);\n  color: #6b6258;\n}\n.aap__note-avatar--applicant {\n  background: rgba(22, 163, 74, 0.1);\n  color: #16a34a;\n}\n\n.aap__note-body {\n  flex: 1;\n  min-width: 0;\n}\n.aap__note-meta {\n  font-size: 0.72rem;\n  color: var(--admin-muted);\n  margin: 0 0 0.3rem;\n}\n.aap__note-text {\n  font-size: 0.84rem;\n  color: var(--admin-text);\n  line-height: 1.6;\n  margin: 0;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n/* Compose box */\n.aap__notes-compose {\n  padding: 0.85rem 1rem;\n  border-top: 1px solid var(--admin-border);\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  background: #fafaf9;\n}\n.aap__notes-compose--applicant {\n  background: rgba(22, 163, 74, 0.03);\n}\n\n.aap__notes-input {\n  width: 100%;\n  border: 1px solid var(--admin-border);\n  border-radius: 7px;\n  padding: 0.6rem 0.75rem;\n  font-size: 0.84rem;\n  font-family: inherit;\n  color: var(--admin-text);\n  resize: none;\n  outline: none;\n  transition: border-color 0.15s;\n  background: #fff;\n  box-sizing: border-box;\n}\n.aap__notes-input:focus {\n  border-color: var(--admin-rust);\n  box-shadow: 0 0 0 2px rgba(var(--admin-rust-rgb), 0.09);\n}\n\n.aap__notes-compose-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n.aap__notes-hint {\n  font-size: 0.67rem;\n  color: var(--admin-muted);\n}\n\n.aap__notes-applicant-warn {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.4rem;\n  font-size: 0.75rem;\n  color: #15803d;\n  background: rgba(22, 163, 74, 0.07);\n  border: 1px solid rgba(22, 163, 74, 0.2);\n  border-radius: 6px;\n  padding: 0.55rem 0.7rem;\n  line-height: 1.45;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   MOBILE RESPONSIVE — viewer\n═══════════════════════════════════════════════════════════ */\n@media (max-width: 767px) {\n  /* Viewer takes full screen, no negative margin overflow */\n  .aap__viewer {\n    margin: -1rem -1rem 0;\n  }\n\n  /* Top bar stacks */\n  .aap__viewer-bar {\n    padding: 0.75rem 1rem;\n    gap: 0.6rem;\n  }\n  .aap__viewer-actions {\n    width: 100%;\n    justify-content: flex-end;\n    gap: 0.4rem;\n    flex-wrap: wrap;\n  }\n  .aap__viewer-actions-group {\n    width: 100%;\n  }\n  .aap__viewer-status-select {\n    flex: 1;\n    min-width: 0;\n  }\n\n  /* Safety banner: less side margin to match content padding */\n  .aap__safety-banner {\n    margin: 0 0.9rem;\n  }\n\n  /* Content: single column, no side padding */\n  .aap__viewer-content {\n    grid-template-columns: 1fr;\n    padding: 0.85rem 0.9rem;\n    gap: 0.85rem;\n  }\n\n  /* Header: avatar + info stack */\n  .aap__viewer-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n    padding: 1rem;\n  }\n  .aap__viewer-avatar {\n    width: 3rem;\n    height: 3rem;\n    font-size: 1.1rem;\n  }\n  .aap__viewer-name {\n    font-size: 1.1rem;\n  }\n\n  /* Tabs: scrollable if overflow */\n  .aap__viewer-tabs {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    padding-bottom: 1px;\n    flex-wrap: nowrap;\n    scrollbar-width: none;\n  }\n  .aap__viewer-tabs::-webkit-scrollbar {\n    display: none;\n  }\n  .aap__viewer-tab {\n    white-space: nowrap;\n    font-size: 0.78rem;\n    padding: 0.65rem 0.85rem;\n  }\n\n  /* Info rows: stack label/value */\n  .aap__info-row {\n    flex-direction: column;\n    gap: 0.15rem;\n  }\n  .aap__info-label {\n    min-width: unset;\n  }\n  .aap__info-value {\n    text-align: left;\n  }\n\n  /* Table: horizontal scroll */\n  .aap__table-card {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .aap__table {\n    min-width: 580px;\n  }\n\n  /* Filters: wrap, search takes full width first */\n  .aap__filters {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n  .aap__search-wrap {\n    width: 100%;\n    min-width: 0;\n    flex-basis: 100%;\n  }\n\n  /* Sidebar below main on mobile */\n  .aap__viewer-sidebar {\n    position: static;\n  }\n}\n\n@media (max-width: 479px) {\n  .aap__viewer-bar {\n    padding: 0.65rem 0.75rem;\n  }\n  .aap__viewer-content {\n    padding: 0.65rem 0.75rem;\n  }\n  .aap__safety-banner {\n    margin: 0 0.75rem;\n    padding: 0.75rem 0.85rem;\n  }\n  .aap__viewer-tab {\n    padding: 0.55rem 0.65rem;\n    font-size: 0.73rem;\n  }\n  .aap__notes-compose {\n    padding: 0.65rem 0.75rem;\n  }\n  .aap__note-card {\n    padding: 0.7rem 0.75rem;\n  }\n}\n\n/* ── Ban / Unban buttons ── */\n.aap__ban-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  width: 100%;\n  padding: 0.6rem;\n  border: 1.5px solid rgba(27, 27, 27, 0.25);\n  border-radius: 7px;\n  background: transparent;\n  color: #1b1b1b;\n  font-size: 0.8rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.15s;\n  margin-top: 0.25rem;\n}\n.aap__ban-btn:hover:not(:disabled) {\n  background: rgba(27, 27, 27, 0.06);\n  border-color: #1b1b1b;\n}\n.aap__ban-btn:disabled {\n  opacity: 0.5;\n  cursor: wait;\n}\n\n.aap__unban-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  width: 100%;\n  padding: 0.6rem;\n  border: 1.5px solid rgba(22, 163, 74, 0.35);\n  border-radius: 7px;\n  background: rgba(22, 163, 74, 0.06);\n  color: #15803d;\n  font-size: 0.8rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.15s;\n  margin-top: 0.25rem;\n}\n.aap__unban-btn:hover:not(:disabled) {\n  background: rgba(22, 163, 74, 0.12);\n}\n.aap__unban-btn:disabled {\n  opacity: 0.5;\n  cursor: wait;\n}\n\n/* Banned status bulk button */\n.abulk__status-btn--banned {\n  background: rgba(27, 27, 27, 0.08);\n  border-color: rgba(27, 27, 27, 0.3);\n  color: #1b1b1b;\n}\n.abulk__status-btn--banned:hover:not(:disabled) {\n  background: rgba(27, 27, 27, 0.14);\n}\n\n/* ── Applicant note replies (admin view) ── */\n.aap__note-thread {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n.aap__note-replies {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  margin-left: 2.65rem;\n  border-left: 2px solid rgba(184, 92, 56, 0.2);\n}\n.aap__note-reply {\n  display: flex;\n  gap: 0.6rem;\n  align-items: flex-start;\n  padding: 0.65rem 0.85rem;\n  border-bottom: 1px solid var(--admin-border);\n  background: rgba(184, 92, 56, 0.03);\n}\n.aap__note-reply:last-child {\n  border-bottom: none;\n}\n.aap__note-reply-avatar {\n  width: 1.7rem;\n  height: 1.7rem;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background: #b85c38;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.65rem;\n  font-weight: 800;\n}\n.aap__note-reply-body {\n  flex: 1;\n  min-width: 0;\n}\n.aap__note-reply-file {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  margin-top: 0.35rem;\n  font-size: 0.75rem;\n  color: #b85c38;\n  background: rgba(184, 92, 56, 0.08);\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n}\n.aap__note-no-reply {\n  font-size: 0.72rem;\n  color: var(--admin-muted);\n  font-style: italic;\n  padding: 0.4rem 0.85rem 0.65rem 3.5rem;\n}\n\n@media (max-width: 767px) {\n  .aap__note-replies {\n    margin-left: 1.3rem;\n  }\n  .aap__note-no-reply {\n    padding-left: 1.8rem;\n  }\n}\n\n/* ── Documents tab — two-section layout ── */\n.aap__docs-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.aap__docs-section-head {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid var(--admin-border);\n  background: var(--admin-surface);\n  flex-wrap: wrap;\n}\n.aap__docs-section-title {\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n  flex: 1;\n}\n.aap__docs-section-badge {\n  font-size: 0.65rem;\n  font-weight: 800;\n  background: rgba(107, 98, 88, 0.12);\n  color: var(--admin-muted);\n  padding: 0.18rem 0.55rem;\n  border-radius: 99px;\n}\n.aap__docs-section-badge--rust {\n  background: rgba(184, 92, 56, 0.1);\n  color: var(--admin-rust);\n}\n\n.aap__docs-section-sub {\n  font-size: 0.75rem;\n  color: var(--admin-muted);\n  margin: 0;\n  padding: 0.5rem 1rem 0;\n  line-height: 1.5;\n}\n\n.aap__doc-icon--rust {\n  color: var(--admin-rust) !important;\n}\n\n.aap__doc-note-ctx {\n  font-style: italic;\n  color: var(--admin-muted);\n  font-size: 0.7rem;\n}\n\n@media (max-width: 479px) {\n  .aap__doc-card {\n    flex-wrap: wrap;\n  }\n}\n\n/* ── Pipeline steps ── */\n.aap__pipeline {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem 0;\n  flex-wrap: wrap;\n  margin-bottom: 0.85rem;\n}\n.aap__pipeline-step {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n.aap__pipeline-step:not(:last-child)::after {\n  content: \"→\";\n  font-size: 0.7rem;\n  color: var(--admin-muted);\n  margin: 0 0.35rem;\n}\n.aap__pipeline-dot {\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 50%;\n  border: 2px solid var(--admin-border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--admin-muted);\n  background: #fff;\n  flex-shrink: 0;\n}\n.aap__pipeline-dot--done {\n  background: #1e2a1e;\n  border-color: #1e2a1e;\n  color: #fff;\n}\n.aap__pipeline-label {\n  font-size: 0.74rem;\n  font-weight: 600;\n  color: var(--admin-muted);\n  white-space: nowrap;\n}\n.aap__pipeline-label--done {\n  color: #1e2a1e;\n}\n.aap__pipeline-actions {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n/* On narrow screens, drop the arrow connectors and stack pipeline steps into\n   a compact wrapped list instead — arrows orphaning at line-wraps looked broken */\n@media (max-width: 560px) {\n  .aap__pipeline {\n    gap: 0.5rem 0.75rem;\n  }\n  .aap__pipeline-step:not(:last-child)::after {\n    content: \"\";\n    margin: 0;\n  }\n  .aap__pipeline-step {\n    background: var(--admin-surface);\n    padding: 0.3rem 0.55rem 0.3rem 0.3rem;\n    border-radius: 99px;\n  }\n}\n\n/* ── Prescreening Responses ── */\n.aap__prescreening {\n  display: flex;\n  flex-direction: column;\n  gap: 1.1rem;\n}\n.aap__prescreening-date {\n  font-size: 0.76rem;\n  color: var(--admin-muted);\n  margin: 0 0 0.25rem;\n  padding-bottom: 0.6rem;\n  border-bottom: 1px solid var(--admin-border);\n}\n.aap__prescreening-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n.aap__prescreening-heading {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--admin-rust);\n  margin: 0;\n}\n.aap__prescreening-row {\n  padding: 0.5rem 0;\n  border-bottom: 1px solid var(--admin-border);\n}\n.aap__prescreening-row:last-child {\n  border-bottom: none;\n}\n.aap__prescreening-q {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--admin-text);\n  margin: 0 0 0.25rem;\n  line-height: 1.5;\n}\n.aap__prescreening-a {\n  font-size: 0.84rem;\n  color: var(--admin-muted);\n  margin: 0;\n  line-height: 1.6;\n  white-space: pre-wrap;\n}\n\n/* ── Medical Clearance status block ── */\n.aap__medical-status {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n.aap__medical-line {\n  font-size: 0.85rem;\n  color: var(--admin-text);\n  margin: 0;\n}\n.aap__medical-line strong {\n  color: var(--admin-text);\n}\n.aap__medical-hint {\n  font-size: 0.75rem;\n  color: var(--admin-muted);\n  margin: 0.35rem 0 0;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
